import BaseLayer from './BaseLayer';
import { removeSourceAndLayers, setVisibility, wmsSourceTiles } from '../utils/maplibre-helpers';

const FLOOD_SCENARIOS = [
    {
        key: '02',
        url: 'https://wody.isok.gov.pl/gpservices/KZGW/MZP22_Glebokosc_NiskiePrawdopodPowodzi/MapServer/WMSServer',
        layers: '1,16',
        opacity: 0.3,
        brightnessMin: 0.18,
        brightnessMax: 0.94,
        saturation: -0.05,
        contrast: -0.04
    },
    {
        key: '1',
        url: 'https://wody.isok.gov.pl/gpservices/KZGW/MZP22_Glebokosc_SredniePrawdopodPowodzi/MapServer/WMSServer',
        layers: '1,16',
        opacity: 0.38,
        brightnessMin: 0.12,
        brightnessMax: 0.88,
        saturation: 0.08,
        contrast: 0.08
    },
    {
        key: '10',
        url: 'https://wody.isok.gov.pl/gpservices/KZGW/MZP22_Glebokosc_WysokiePrawdopodPowodzi/MapServer/WMSServer',
        layers: '0',
        opacity: 0.58,
        brightnessMin: 0.04,
        brightnessMax: 0.7,
        saturation: 0.22,
        contrast: 0.18
    }
];

const FLOOD_RENDER_MODES = [
    {
        key: 'overview',
        requestSize: 768,
        minZoom: 12,
        maxZoom: 14
    },
    {
        key: 'detail',
        requestSize: 256,
        minZoom: 14,
        maxZoom: 22
    }
];

export default class PowodzLayer extends BaseLayer {
    static ID = 'powodz';
    static DESCRIPTION = 'Zagrożenie powodziowe: scenariusze 0,2%, 1% i 10% (Wody Polskie)';
    static MIN_ZOOM = 12;

    getScenarioLayerId(scenario, mode) {
        return this.id + '-' + scenario.key + '-' + mode.key;
    }

    getScenarioSourceId(scenario, mode) {
        return 'src-' + this.getScenarioLayerId(scenario, mode);
    }

    getLayerIds() {
        return FLOOD_SCENARIOS.reduce((layerIds, scenario) => {
            FLOOD_RENDER_MODES.forEach((mode) => {
                layerIds.push(this.getScenarioLayerId(scenario, mode));
            });
            return layerIds;
        }, []);
    }

    load() {
        if (!this.canActivate()) {
            this.clear();
            return;
        }

        const map = this.getMap();
        if (!map) return;

        FLOOD_SCENARIOS.forEach((scenario) => {
            FLOOD_RENDER_MODES.forEach((mode) => {
                const sourceId = this.getScenarioSourceId(scenario, mode);
                const layerId = this.getScenarioLayerId(scenario, mode);

                if (!map.getSource(sourceId)) {
                    map.addSource(sourceId, {
                        type: 'raster',
                        tiles: [wmsSourceTiles(scenario.url, {
                            LAYERS: scenario.layers,
                            FORMAT: 'image/png',
                            TRANSPARENT: 'true',
                            VERSION: '1.3.0',
                            WIDTH: mode.requestSize,
                            HEIGHT: mode.requestSize
                        })],
                        tileSize: 256,
                        attribution: '&copy; <a href="https://wody.isok.gov.pl/">Wody Polskie</a> ISOK'
                    });

                    map.addLayer({
                        id: layerId,
                        type: 'raster',
                        source: sourceId,
                        minzoom: mode.minZoom,
                        maxzoom: mode.maxZoom,
                        paint: {
                            'raster-opacity': scenario.opacity,
                            'raster-brightness-min': scenario.brightnessMin,
                            'raster-brightness-max': scenario.brightnessMax,
                            'raster-saturation': scenario.saturation,
                            'raster-contrast': scenario.contrast
                        }
                    });
                }

                setVisibility(map, layerId, true);
            });
        });

        if (this.config.onLoaded) {
            this.config.onLoaded();
        }
    }

    clear() {
        const map = this.getMap();
        if (!map) return;

        FLOOD_SCENARIOS.forEach((scenario) => {
            FLOOD_RENDER_MODES.forEach((mode) => {
                const sourceId = this.getScenarioSourceId(scenario, mode);
                const layerId = this.getScenarioLayerId(scenario, mode);
                removeSourceAndLayers(map, sourceId, [layerId]);
            });
        });

        if (this.config.onCleared) {
            this.config.onCleared();
        }
    }
}
